import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/document`;


const baseUrl2 = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/application-document`;

export const documentService = {
  downloadDocument,
  getAll,
  search,
  getSuggestion,
  getById,
  create,
  create2,
  update,
  delete: _delete,
};

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/suggestion${params}`);
}


function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

  function create(params) {
    return fetchWrapper.post(baseUrl, params);
  }

  function create2(params) {
    return fetchWrapper.post(baseUrl2, params);
  }
// function uploadFile(params) {
//   return fetchWrapper.post(`${baseUrl}/upload`, params);
// }

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function downloadDocument(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`, { responseType: "blob" });
}
